import React, { useContext, useEffect } from "react";
import { SurveyContext } from "../../store/survey-context";
import { useTranslation } from "react-i18next";
import Cta from "../cta/Cta";
import ShareIcons from "../shareIcons/shareIcons";
import { setAppBackground } from "../../utils";
import "./share.scss";

export default function Share(props) {
  const { userProfile } = useContext(SurveyContext);
  const { t } = useTranslation("common");

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setAppBackground("Ring_Viz_BG_v2.png", 0);
  }, []);

  // generated image placeholder
  const image = (
    <img
      className="share-view__image"
      src={props.image}
      alt={t("journey.woodcut", { username: userProfile.firstName })}
    />
  );

  return (
    <div className="share-view container fade-in">
      <div className="share-view__content">
        <div className="share-view__data">
          <div className="share-view__text">
            <div className="share-view__header">
              <h1>
                <span className="share-view__title">
                  {t("journey.share_title")}
                </span>
                <span className="share-view__subtitle">
                  {t("journey.share_subtitle")}
                </span>
              </h1>
            </div>
            <div className="share-view__data-image-container">{image}</div>

            <p className="share-view__message paragraph">
              {t("journey.share_message")}
            </p>
          </div>
          <ShareIcons image={props.image} />
        </div>
        {props.image && (
          <div className="share-view__image-container fade-in">{image}</div>
        )}
      </div>
      <ShareIcons
        image={props.image}
        modifyingClass="share-view__links-container--small-screen"
      />
      <div className="share-view__button-container">
        <Cta
          path="/recommendations"
          ctaClass="cta--secondary cta--centered prev"
        >
          {t("button.go_back")}
        </Cta>
      </div>
    </div>
  );
}
